import React, { useState } from "react";
import { BsChevronDoubleRight, BsLinkedin } from "react-icons/bs";
import { ImFacebook2 } from "react-icons/im";
import { BiChevronsRight } from "react-icons/bi";
import { Link } from "react-router-dom";
import { FaLinkedin } from "react-icons/fa";

const Footer = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    debtRestructuring: "",
    phoneNumber: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  return (
    <>
      <div className=" bg-slate-800 grid gap-5 grid-cols-1 lg:grid-cols-4  py-20  text-white px-[10px] md:px-[20px] lg:px-[7%]">
        <div>
          {/* <img src="/images/notionrecovery.png" alt="" /> */}
          <p className="py-5">
            Maximize your productivity with our top-notch monitors. Crisp
            visuals and enhanced efficiency at your service.
          </p>

          <Link
            className=" group-hover:text-pbtn text-slate-400 font-bold   text-sm border-b-2 group-hover:border-pbtn"
            to="/services"
          >
            About us
          </Link>

          <div className="flex  items-center py-5">
            <Link to="fb.com">
              <ImFacebook2 className=" mr-2 text-3xl " />
            </Link>
            <Link to="linkedIn.com" className="">
              <FaLinkedin className=" mr-2 text-3xl " />
            </Link>
          </div>
        </div>

        <div>
          <h3 className=" font-bold mb-3 text-lg">Services</h3>
          <div>
            <ul>
              <li data-aos="fade-up" data-aos-duration="1000">
                <span>
                  <BiChevronsRight className="inline-block" />
                </span>
                <Link to="/">Home Delivery</Link>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay="100"
              >
                <span>
                  <BiChevronsRight className="inline-block" />
                </span>
                <Link to="/">24h Support</Link>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay="200"
              >
                <span>
                  <BiChevronsRight className="inline-block" />
                </span>
                <Link to="/">Return Policy</Link>
              </li>
              {/* Add more list items with AOS attributes */}
            </ul>
          </div>
        </div>

        <div>
          <h3 className=" font-bold mb-3 text-lg">Company</h3>
          <div>
            <ul>
              <li data-aos="fade-up" data-aos-duration="1000">
                <span>
                  <BiChevronsRight className="inline-block" />
                </span>
                <Link to="/">Home</Link>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay="100"
              >
                <span>
                  <BiChevronsRight className="inline-block" />
                </span>
                <Link to="/">About</Link>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay="200"
              >
                <span>
                  <BiChevronsRight className="inline-block" />
                </span>
                <Link to="/">Services</Link>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay="200"
              >
                <span>
                  <BiChevronsRight className="inline-block" />
                </span>
                <Link to="/">Blog</Link>
              </li>

              {/* Add more list items with AOS attributes */}
            </ul>
          </div>
        </div>

        <div>
          <h3 className=" font-bold mb-3 text-lg">Subcribe</h3>
          <h1 className=" text-3xl font-bold">Wasi Store</h1>
        </div>
      </div>

      {/* 2nd part */}
      <div className=" bg-slate-800 text-white py-5 flex flex-col justify-center items-center lg:justify-between lg:flex-row    px-[10px] md:px-[20px] lg:px-[7%]">
        <p className="text-center">
          @2023 Notion Debt Recovery by Notion Universe Sdn Bhd
        </p>
        <div>
          <Link className="mx-5" to="/terms">
            Terms and Conditions{" "}
          </Link>
          <Link className="mx-5" to="/terms">
            Privacy Policy{" "}
          </Link>
        </div>
      </div>
    </>
  );
};

export default Footer;
